import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PlannedAccessesTreatmentFields} from '@/features/planned-accesses/components/accesses-form/planned-accesses-treatment-fields/PlannedAccessesTreatmentFields'
import {PlannedAccessesTotalCard} from '@/features/planned-accesses/components/planned-accesses-total-card/PlannedAccessesTotalCard'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {useGetProject} from '@/features/projects/queries/useGetProject'
import {calculateTotalAccesses} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const PlannedAccessesTreatmentSchema = PlannedAccessesFieldsSchema.pick({
    projectId: true,
    inPersonAccesses: true
})
type PlannedAccessesTreatmentSchema = z.infer<typeof PlannedAccessesTreatmentSchema>

export const PlannedAccessesFormTreatmentSection = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesTreatmentSchema>()
    const projectId = useWatch({control, name: 'projectId'})
    const {data: project, isLoading: isProjectLoading} = useGetProject({
        urlParams: {projectId: projectId},
        params: {responseType: 'extended'},
        options: {enabled: !!projectId}
    })

    const inPersonAccesses = useWatch({control, name: 'inPersonAccesses'})

    const totalTreatments = inPersonAccesses?.reduce((acc, curr) => {
        return acc + calculateTotalAccesses(project?.durationDays ?? 0, curr.frequency, curr.numberOfAccesses || 0)
    }, 0)

    return (
        <FormSection
            title={t('planned_accesses:treatments')}
            description={t('planned_accesses:patient_in_person')}
            hasBottomDivider
            fullWidth
        >
            <Flexbox direction="column" gap={6}>
                <PlannedAccessesTotalCard title={t('planned_accesses:total_treatments')} total={totalTreatments} />
                <PlannedAccessesTreatmentFields
                    isLoadingProject={isProjectLoading}
                    projectDurationDays={project?.durationDays}
                />
            </Flexbox>
        </FormSection>
    )
}
